import page0 from "./_0_employment_visa_information";
import page1 from "./_1_point_of_contact_information";
import page2 from "./_2_employer_information";
import page3 from "./_3_agent_or_attorney_information";
import page4 from "./_4_job_description";
import page5 from "./_5_minimum_job_requirements";
import page6 from "./_6_place_of_employment_information";
import page7 from "./_7_addendum_A_other_worksites";

const form_meta = {
  code: "Form ETA-9141C",
  name: "CW-1 Prevailing Wage Determination",
};

const form_nav = [
  {
    name: "Employment-Based Visa Information",
    prefix: "A",
  },
  {
    name: "Requestor Point-of-Contact Information",
    prefix: "B",
  },
  {
    name: "Employer Information",
    prefix: "C",
  },
  {
    name: "Attorney or Agent Information",
    prefix: "D",
  },
  {
    name: "Job Description",
    prefix: "E.a",
  },
  {
    name: "Minimum Job Requirements",
    prefix: "E.b",
  },
  {
    name: "Place of Employment Information",
    prefix: "E.c",
  },
  {
    name: "Additional  Worksites",
    prefix: "ADD",
    classes: "label-prefix-appx",
    relevantValue: "otherWorksites",
  },
];

const uiSchema = [page0, page1, page2, page3, page4, page5, page6, page7];

export { form_meta, form_nav };

export default uiSchema;
